const dfPhotosVideos = {
  introHead: 'Organisieren Sie Ihre Dateien',
  introDescription:
    'Wir helfen Ihnen wichtige Bilder und Videos zu organisieren und sicher zu speichern.',
};

export default dfPhotosVideos;
